import './common.scss';
import {lazy} from 'react';
import MessageDialog from './Message/Message.dialog';

const ConvertResultMessage = lazy(()=>import('./ProcessMessage/ConvertResultMessage'))
const NotificationMessage = lazy(()=>import('./ProcessMessage/NotificationMessage'))
const HtmlToPDFDialog = lazy(()=>import('./HtmlToPDF/HtmlToPDF.dialog'))
const ExportImagesDialog = lazy(()=>import('./ExportImages/ExportImages.dialog'))
const PDFToImageDialog = lazy(()=>import('./PDFToImage/PDFToImage.dialog'))
const SignInNoticeDialog = lazy(()=>import('./SignInNotice/SignInNotice.dialog'))
const SaveToDialog = lazy(()=>import('./SaveTo/SaveTo.dialog'))
const SaveAsDialog = lazy(()=>import('./SaveAs/SaveAs.dialog'))
const SecurityPolicies = lazy(()=>import('./SecurityPolicies/SecurityPolicies.dialog'))
const CertificateProtectDialog = lazy(()=>import('./CertificateProtect/CertificateProtect.dialog'))
const DigitalIDsDialog = lazy(()=>import('./DigitalIDs/DigitalIDs.dialog'))
const ChooseFiles4Organize = lazy(()=>import('./ChooseFiles4Organize'))
const ToDoMessageDialog = lazy(()=>import('./Message/ToDoMessage.dialog'))
const ToDoMessageDialog2 = lazy(()=>import('./Message/ToDoMessageDialog2'))
const ToDoMessageTemplatePlugin = lazy(()=>import('./Message/ToDoMessageTemplatePlugin'))
const MessageDialogStore = lazy(()=>import('./Message/Message.inStore'))
const TrustManagerDialog = lazy(()=>import('./TrustManager/TrustManager.dialog'))
const TemplateDialog = lazy(()=>import('./TemplateDlg/Template.dialog'))
const WatermarkDialog = lazy(()=>import('./Watermark/Watermark.dialog'))
const FlattenPageDlg = lazy(()=>import('./FlattenPage/FlattenPage.dialog'))
const AddHeaderFooter = lazy(()=>import('./AddHeaderFooter/HeaderFooter.dialog'));
const SubscribeDialog = lazy(()=>import('./account/Subscribe.dialog'));
const RedeemedDialog = lazy(()=>import('./account/Redeemed.dialog'));
import PreferencesDialog from './Preferences/Preferences.dialog';
const FormTipsMessage = lazy(()=>import('./ProcessMessage/FormTipsMessage'));
const Redeem = lazy(()=>import('./RedeemDlg/Redeem.page'))
const ExportFormDataDialog = lazy(()=>import('./ExportFormData/ExportFormDataDialog'))
const AboutFoxitDialog = lazy(()=>import('./AboutFoxit/AboutFoxit.dialog'))
const ShareDlg = lazy(()=>import('./ShareDlg/ShareDlg'))
const FwShareDlg = lazy(()=>import('../fwComponents/ShareDlg/ShareDlg'))
const Tips = lazy(()=>import('./Message/Tips'))
const TermsChangeMessageDialog = lazy(()=>import('./Message/TermsChangeMessage.dialog'))
const AppendWebLinksdialog = lazy(()=>import('./AppendWebLinks/AppendWebLinks.dialog'))
const EditViewWebLinksDlg = lazy(()=>import('./EditViewWebLinks/EditViewWebLinks.dialog'))
const BackgroundDialog = lazy(()=>import('./Background/Background.dialog'))
const CompareDialog = lazy(()=>import('./Compare/Compare.dialog'))
const ScannedEditingSetting = lazy(()=>import("./ScannedEditingSetting/index"))
const BatesNumberingDialog = lazy(()=>import('./BatesNumbering/Index'))
const MessageCenter = lazy(()=>import('./MessageCenter/index'))
const PageTransitionsDialog = lazy(()=>import('./pageTransitions/'))
const CollaborationSignIn = lazy(()=>import("./CollaborationSignIn/CollaborationSignIn"))
// const CreateNewAction = lazy(()=>import('./ActionWizard/create'))
// const RunAction = lazy(()=>import('./ActionWizard/runAction'))
// const ManageActions = lazy(()=>import('./ActionWizard/manageActions'))
const ConvertPopupDlg = lazy(()=>import("./ConvertPopup/ConvertPopup.dialog"))
const ImportCommentDlg = lazy(()=>import("./ImportComment/ImportComment.dialog"))
const CommentStatisticsResultDlg = lazy(()=>import("./CommentStatisticsResult/CommentStatisticsResult.dialog"))
const PwaTipsDlg = lazy(()=>import("./PwaTips/PwaTips.dialog"));
const CompareResult = lazy(()=>import('./Compare/components/CompareResult'));
const AddDigitalID = lazy(()=>import('./AddDigitalID'))
const SignResultDialog = lazy(()=>import("./SignResultDialog/index"))

import PluginInstallDlg from "./PluginInstall/PluginInstall.dialog";
import HeaderEntrance from './PaymentDlg/HeaderEntrance';
import PaymentDialog from './PaymentDlg/PaymentDialog';
import BundlePaymentDialog from './PaymentDlg/BundlePaymentDialog';

const EsignCnPagingSeal = lazy(() => import('./ESignCN/PagingSeal'));
const EsignCnManageOutSeals = lazy(() => import('./ESignCN/ManageOutSeals'))
const PaperCheckDialog = lazy(()=>import('../PaperCheck/PaperCheckDialog'))
const PaperCheckNoticeInfoDialog = lazy(()=>import('../PaperCheck/PaperCheckNotice/PaperCheckNoticeInfoDialog'))
const PaperCheckMessageDialog = lazy(()=>import('../PaperCheck/PaperCheckMessage/PaperCheckMessageDialog'))
const PaperCheckResultNoticeMessage = lazy(()=>import('../PaperCheck/PaperCheckNotice/PaperCheckResultNoticeMessage'));
const PaperCheckHistoryDialog = lazy(()=> import('../PaperCheck/PaperCheckHistory/PaperCheckHistoryDialog'));
const PaperCheckResultDialog = lazy(()=> import('../PaperCheck/PaperCheckResult/PaperCheckResultDialog'));
const PaperCheckDiscountNotice = lazy(()=>import('../PaperCheck/PaperCheckDiscountNotice/PaperCheckDiscountNotice'));
const EsignCnStamp4MultPages = lazy(() => import('./ESignCN/Stamp4MultPages'));
const ESignSwitchAccountsDialog = lazy(()=> import('../ESignSwitchAccounts/ESignSwitchAccountsDialog'))
const EsignCnShareOnlineDocDialog = lazy(()=> import('./ESignCN/ShareOnlineDocDialog'))

const EsignCnOutStampsPanel = lazy(()=> import('./ESignCN/OutStampsPanel'))

const EsignCnApplyOrgSeals = lazy(()=> import('./ESignCN/ApplyOrgSeals'))
const EsignCnAuthPromotion = lazy(() => import('./ESignCN/AuthPromotion'));

export {
    AddDigitalID,
  ConvertResultMessage,
  NotificationMessage,
  HtmlToPDFDialog,
  ExportImagesDialog,
  PDFToImageDialog,
  SignInNoticeDialog,
  SaveToDialog,
  SaveAsDialog,
  SecurityPolicies,
  CertificateProtectDialog,
  DigitalIDsDialog,
  ChooseFiles4Organize,
  MessageDialog,
  ToDoMessageDialog,
  ToDoMessageDialog2,
  TrustManagerDialog,
  WatermarkDialog,
  FlattenPageDlg,
  AddHeaderFooter,
  SubscribeDialog,
  RedeemedDialog,
  PreferencesDialog,
  FormTipsMessage,
  ShareDlg,
  FwShareDlg,
  Redeem,
  ExportFormDataDialog,
  TemplateDialog,
  AboutFoxitDialog,
  ToDoMessageTemplatePlugin,
  MessageDialogStore,
  Tips,
  TermsChangeMessageDialog,
  AppendWebLinksdialog,
  EditViewWebLinksDlg,
  CollaborationSignIn,
  BackgroundDialog,
  CompareDialog,
  ScannedEditingSetting,
  MessageCenter,
  // CreateNewAction,
  // RunAction,
  // ManageActions,
  PageTransitionsDialog,
  BatesNumberingDialog,
  ConvertPopupDlg,
  ImportCommentDlg,
  CommentStatisticsResultDlg,
  PluginInstallDlg,
  CompareResult,
  PwaTipsDlg,
  HeaderEntrance,
  PaymentDialog,
  BundlePaymentDialog,
  SignResultDialog,
  EsignCnPagingSeal,
  EsignCnManageOutSeals,
  PaperCheckDialog,
  PaperCheckNoticeInfoDialog,
  PaperCheckMessageDialog,
  PaperCheckResultNoticeMessage,
  PaperCheckHistoryDialog,
  PaperCheckResultDialog,
  PaperCheckDiscountNotice,
  EsignCnStamp4MultPages,
  ESignSwitchAccountsDialog,
  EsignCnShareOnlineDocDialog,
  EsignCnOutStampsPanel,
  EsignCnApplyOrgSeals,
  EsignCnAuthPromotion,
};
